import { Component, HostBinding, Input } from '@angular/core';
import { ButtonTypeEnum } from './types/button-type.enum';
import { StringHelper } from '../../../helpers/string.helper';
import { ButtonSizeEnum } from './types/button-size.enum';

@Component({
  selector: '[appButton]',
  template: `<ng-content></ng-content>`,
})
export class ButtonComponent {

  @HostBinding('class')
  public get class() {
    return this.generateClasses;
  }

  @Input()
  public set bType(content: ButtonTypeEnum | string) {
    this._type = StringHelper.stringToEnum(ButtonTypeEnum, content) || ButtonTypeEnum.BASIC;
  };

  @Input()
  public set bSize(content: ButtonSizeEnum | string) {
    this._size = StringHelper.stringToEnum(ButtonSizeEnum, content) || ButtonSizeEnum.MEDIUM;
  };

  @Input()
  public set outline(content: boolean | string) {
    if (typeof content === 'string' && content === '') {
      this._outline = true;
      return;
    }

    this._outline = !!content;
  };

  private _type: ButtonTypeEnum = ButtonTypeEnum.BASIC;

  private _size: ButtonSizeEnum = ButtonSizeEnum.MEDIUM;

  private _outline = false;

  private get generateClasses(): string {
    const colors: Record<ButtonTypeEnum, string> = {
      [ButtonTypeEnum.BASIC]: 'bg-lBlueLight dark:bg-lBlueDark hover:opacity-80 focus:ring-lBlueLight/50 dark:focus:ring-lBlueDark/50 border-0 text-color',
      [ButtonTypeEnum.INFO]: 'bg-lInfo dark:bg-lInfo hover:bg-lInfo/90 dark:hover:bg-lInfo/90 focus:ring-lInfo/50 dark:focus:ring-lInfo/50 border-0 text-lWhite',
      [ButtonTypeEnum.SUCCESS]: 'bg-lSuccess dark:bg-lSuccess hover:bg-lSuccess/90 dark:hover:bg-lSuccess/90 focus:ring-lSuccess/50 dark:focus:ring-lSuccess/50 border-0 text-lWhite',
      [ButtonTypeEnum.WARNING]: 'bg-lWarning dark:bg-lWarning hover:bg-lWarning/90 dark:hover:bg-lWarning/90 focus:ring-lWarning/50 dark:focus:ring-lWarning/50 border-0 text-lWhite',
      [ButtonTypeEnum.DANGER]: 'bg-lDanger dark:bg-lDanger hover:bg-lDanger/90 dark:hover:bg-lDanger/90 focus:ring-lDanger/50 dark:focus:ring-lDanger/50 border-0 text-lWhite',
      [ButtonTypeEnum.PRIMARY]: 'bg-lPrimary dark:bg-lPrimary hover:bg-lPrimary/90 dark:hover:bg-lPrimary/90 focus:ring-lPrimary/50 dark:focus:ring-lPrimary/50 border-0 text-lWhite',
    }

    const colorsOutline: Record<ButtonTypeEnum, string> = {
      [ButtonTypeEnum.BASIC]: 'border border-lBlueDark dark:border-lWhite bg-lBlueDark/10 dark:border-lWhite hover:bg-lBlueDark/15 dark:hover:bg-lWhite/15 focus:ring-lBlueLight/50 dark:focus:ring-lBlueDark/50 text-lBlueDark dark:text-lWhite',
      [ButtonTypeEnum.INFO]: 'border !border-lInfo bg-lInfo/10  dark:border-lInfo hover:bg-lInfo/15 dark:hover:bg-lInfo/90 focus:ring-lInfo/50 dark:focus:ring-lInfo/50 text-lInfo',
      [ButtonTypeEnum.SUCCESS]: 'border !border-lSuccess bg-lSuccess/10 dark:border-lSuccess hover:bg-lSuccess/15 dark:hover:bg-lSuccess/90 focus:ring-lSuccess/50 dark:focus:ring-lSuccess/50 text-lSuccess',
      [ButtonTypeEnum.WARNING]: 'border !border-lWarning bg-lWarning/10 dark:border-lWarning hover:bg-lWarning/15 dark:hover:bg-lWarning/90 focus:ring-lWarning/50 dark:focus:ring-lWarning/50 text-lWarning',
      [ButtonTypeEnum.DANGER]: 'border !border-lDanger bg-lDanger/10 dark:border-lDanger hover:bg-lDanger/15 dark:hover:bg-lDanger/90 focus:ring-lDanger/50 dark:focus:ring-lDanger/50 text-lDanger',
      [ButtonTypeEnum.PRIMARY]: 'border !border-lPrimary bg-lPrimary/1 dark:bg-lPrimary/1 dark:border-lPrimary hover:bg-lPrimary/10 dark:hover:bg-lPrimaryLight focus:ring-lPrimary/50 dark:focus:ring-lPrimaryLight text-lPrimary',
    }

    const sizes: Record<ButtonSizeEnum, string> = {
      [ButtonSizeEnum.SMALL]: 'h-8 p-2',
      [ButtonSizeEnum.MEDIUM]: 'h-12 p-3',
      [ButtonSizeEnum.LARGE]: 'h-16 p-4',
    }

    const baseClasses = 'no-underline inline-flex items-center justify-center text-center border-radius focus:outline-none focus:ring w-full cursor-pointer';
    return (this._outline ? colorsOutline[this._type] : colors[this._type]) + ' ' + sizes[this._size] + ' ' + baseClasses;
  }

}
